var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/components/x-buildify-permission-selection.ts
import { getAllEntities } from "@adornis/baseql/operations/mongo.js";
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import { FormField } from "@adornis/formfield/form-field.js";
import "@adornis/popover/x-dropdown-search-selection.js";
import "@adornis/popover/x-dropdown-selection.js";
import { AdornisRoles } from "@adornis/users/db/a-roles.js";
import { html, nothing } from "lit";
import { customElement, state } from "lit/decorators.js";
var XBuildifyPermissionSelection = class extends FormField {
  constructor() {
    super(...arguments);
    this._permissions = new RXController(
      this,
      new Promise(async (res, rej) => {
        try {
          const result = await getAllEntities(AdornisRoles)(AdornisRoles.allFields);
          const permissions = /* @__PURE__ */ new Set();
          for (const role of result) {
            role.permissions.map((p) => permissions.add(p));
          }
          res(Array.from(permissions.values()));
        } catch {
          rej("AdornisRoles wurde in der startup.ts nicht initialisiert.");
        }
      })
    );
  }
  render() {
    const permissions = this._permissions.value;
    if (!permissions || permissions.length === 0)
      return nothing;
    return xComponents(html`
      <x-dropdown-search-selection
        clearable
        .value=${permissions.find((p) => p === this.value.value)}
        .search=${(search) => {
      if (!search)
        return permissions;
      return permissions.filter((p) => p.toLowerCase().includes(search.toLowerCase()));
    }}
        placeholder="Berechtigung"
        @value-picked=${(e) => {
      const value = e.detail.value;
      this.value.next(value);
      this.dispatchEvent(new CustomEvent("value-picked", { detail: { value } }));
    }}
      ></x-dropdown-search-selection>
    `);
  }
};
__decorateClass([
  state()
], XBuildifyPermissionSelection.prototype, "_permissions", 2);
XBuildifyPermissionSelection = __decorateClass([
  customElement("x-buildify-permission-selection")
], XBuildifyPermissionSelection);
export {
  XBuildifyPermissionSelection
};
